import React from 'react';

function QuestionMarkSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.5152 9.97819C20.3454 9.99263 20.1736 10 20 10C19.792 10 19.5864 9.98941 19.3838 9.96874C19.5613 10.6156 19.6562 11.2967 19.6562 11.9999C19.6562 16.2282 16.2282 19.6562 11.9999 19.6562C7.77163 19.6562 4.34366 16.2282 4.34366 11.9999C4.34366 7.77163 7.77163 4.34366 11.9999 4.34366C12.7032 4.34366 13.3843 4.4385 14.0312 4.61608C14.0106 4.41353 14 4.208 14 4C14 3.82644 14.0074 3.6546 14.0218 3.48477C13.3728 3.33125 12.6959 3.25 12 3.25C7.16766 3.25 3.25 7.16766 3.25 12C3.25 16.8323 7.16766 20.75 12 20.75C16.8323 20.75 20.75 16.8323 20.75 12C20.75 11.3041 20.6688 10.6272 20.5152 9.97819Z"
        fill="white"
      />
      <path
        d="M12.0006 7.07877C13.511 7.07877 14.7352 8.3038 14.7343 9.81387C14.7343 10.9721 14.0037 12.005 12.9113 12.3916C12.72 12.4592 12.5844 12.6258 12.5535 12.822L12.5468 12.9077V13.6413C12.5468 13.9433 12.3019 14.1881 11.9999 14.1881C11.7253 14.1881 11.498 13.9858 11.459 13.7221L11.453 13.6413V12.9077C11.453 12.2584 11.8345 11.6751 12.4185 11.4118L12.5466 11.3604C13.2021 11.1284 13.6405 10.5086 13.6405 9.81354C13.6411 8.90743 12.9067 8.17252 12.0003 8.17252C11.0942 8.17197 10.3593 8.90638 10.3593 9.81241C10.3593 10.1144 10.1144 10.3593 9.81241 10.3593C9.51038 10.3593 9.26554 10.1144 9.26554 9.81241C9.26554 8.30204 10.4906 7.07786 12.0006 7.07877Z"
        fill="white"
      />
      <path
        d="M12 15.2812L12.0957 15.2868C12.5036 15.3342 12.8203 15.6809 12.8203 16.1016C12.8203 16.5545 12.453 16.9219 12 16.9219C11.547 16.9219 11.1797 16.5545 11.1797 16.1016C11.1797 15.6809 11.4964 15.3342 11.9043 15.2868L12 15.2812Z"
        fill="white"
      />
      <circle cx="20" cy="4" fill="#2382FF" r="4" />
    </svg>
  );
}

export default QuestionMarkSolid;
